export const spring = {
  snappy: { type: 'spring', stiffness: 600, damping: 34, mass: 0.8 },
  standard: { type: 'spring', stiffness: 320, damping: 28 },
  gentle: { type: 'spring', stiffness: 140, damping: 18 },
};

export const timing = {
  scoreLightMs: 1400,
  savedLabelMs: 1500,
  undoMs: 5000,
  rankMoveMs: 2600,
  oddsMoveMs: 2400,
};

export const shake = { x: [0, -9, 9, -6, 6, -3, 0], transition: { duration: 0.42 } };
